import React from 'react';
import {
  HashRouter, Redirect, Route, Switch,
} from 'react-router-dom';
import { Spin } from 'antd';
import { getLocalStorage } from 'utils/CommonFunction';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback, handleError, handleReset } from './ErrorFallback';

const DefaultLayout = React.lazy(() => import('layouts'));
const Login = React.lazy(() => import('pages/Login'));
const ResetPassword = React.lazy(() => import('pages/ResetPassword'));
const ForgotPassword = React.lazy(() => import('pages/ForgotPassword'));

const loading = (
  <div style={{
    height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center',
  }}
  >
    <Spin size="large" />
  </div>
);

const App = () => (
  <ErrorBoundary FallbackComponent={ErrorFallback} onError={handleError} onReset={handleReset}>
    <HashRouter>
      <React.Suspense fallback={loading}>
        <Switch>
          <Route
            exact
            path="/login"
            name="Login Page"
            render={(props) => (getLocalStorage('token_mcv') && !getLocalStorage('oldPassword')
              ? <Redirect to="/merchant-profile" /> : <Login {...props} />)}
          />
          <Route exact path="/reset-password" name="Reset password" render={(props) => <ResetPassword {...props} />} />
          <Route exact path="/forgot-password" name="Forgot password" render={(props) => <ForgotPassword {...props} />} />
          <Route
            path="/"
            name="Home"
            render={(props) => (getLocalStorage('token_mcv') ? <DefaultLayout {...props} /> : <Redirect to="/login" />)}
          />
        </Switch>
      </React.Suspense>
    </HashRouter>
  </ErrorBoundary>
);

export default App;
